import React, { Component } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { isMobile, pianoParser, aspectRatio as ar } from "../../../../../common/parameters";
import handleTouch from "../../../../../common/helpers/handleTouch";

import voices from "../../../../voices";
import Icon from "../../../../icon";

import Score from "../../../Score/score-display";

import Wrapper from "../../Wrapper";

import getBirdsPath from "../Common/getBirdsPath";
import MessageDisplay from "../Common/MessageDisplay";
import NotEdited from "../Common/NotEdited";
import play, { resetPlay } from "../Common/play";
import setUp from "../Common/setupNotation";
import getKeyOffset from "../Common/getKeyOffset";
import { checkReady, submit, failedInput } from "../Common/submitNotation";
import { selectNote, deletePitch } from "../Common/selectNoteNotation";
import getScale from "../Common/getScale";
import getScore from "../Common/getScore";
import scrollToBar from "../Common/scrollToBar";

import { SubmitButton, PlayBtn, CheckPlayBtn, Label, TopRight, DeleteButton } from "../common-style";

import HandSignLadder from "./HandSignLadder";
import {
    ScoreWrapper,
    HandSignLadderWrapper,
    Asset1Wrapper,
    Asset2Wrapper,
    Asset3Wrapper,
    handSignWidth,
    HandSignSharpButton,
    HandSignFlatButton,
    EasterBackground,
    ChristmasBackground,
} from "./styles";
import messages from "./messages";
import { getAlternates } from "./utils";
import { IProps, IState } from "./interfaces";
import { INotationThis } from "../Common/interfaces";
import { ICurrentNote, IPitch, IScore } from "../../../../../common/types";
import { getAccidentals } from "../../../Score/score-display/utils";
import { parseDo } from "../../../Score/methods/changeDo";
import PopupModulation from "../../../PopupModulation";


class HandSign extends Component<IProps, IState> {
    static defaultProps = {
        handlePlayCount: () => { },
        handleFailCount: () => { },
    };
    play = play.bind(this as unknown as INotationThis);
    setUp = setUp.bind(this as unknown as INotationThis);
    checkReady = checkReady.bind(this as unknown as INotationThis);
    submit = submit.bind(this as unknown as INotationThis);
    failedInput = failedInput.bind(this as unknown as INotationThis);
    selectNote = selectNote.bind(this as unknown as INotationThis);
    deletePitch = deletePitch.bind(this as unknown as INotationThis);
    failedNoteTimer?: ReturnType<typeof setInterval>;
    distribution?: number[][];
    scoreRef?: HTMLDivElement;
    pauseOffset?: number;
    isCheckPlayPause?: boolean;
    firstPitch?: {
        bar: number,
        note: number,
    }
    constructor(props: IProps) {
        super(props);
        this.state = {
            submitable: false,
            submited: false,
            playing: false,
            completed: false,
            currentNote: null,
            notes: [],
            incorrectNotes: [],
            playingNote: [],
            activeVoice: 0,
            failedNote: false,
            alteration: 0,
            playable: false,
            solfaNameTypes: [],
            doPos: {
                alt: 0,
                value: 0,
            },
            alternatedPitches: [],
            popupModulation: undefined,
        };
        if (props.setReset) {
            props.setReset(this.resetTask);
        }
        if (props.saveState) {
            props.saveState(this.saveState);
        }
        if (props.restoreState) {
            props.restoreState(this.restoreState);
        }
        if (props.showSolution) {
            props.showSolution(this.showSolution);
        }
    }
    resetTask = () => {
        this.setUp();

        this.setState({
            submitable: false,
            submited: false,
            completed: false,
            incorrectNotes: [],
            activeVoice: 0,
        });
    };
    saveState = () => {
        return {
            currentNote: this.state.currentNote,
            submited: this.state.submited,
            taskScore: this.state.taskScore,
            incorrectNotes: this.state.incorrectNotes,
            submitable: this.state.submitable,
            completed: this.state.completed,
            activeVoice: this.state.activeVoice,
        };
    };
    restoreState = (state: Partial<IState>) => {
        this.setState({
            currentNote: state.currentNote!,
            submited: state.submited!,
            taskScore: state.taskScore,
            incorrectNotes: state.incorrectNotes!,
            submitable: state.submitable!,
            completed: state.completed!,
            activeVoice: state.activeVoice!,
        });
    };
    showSolution = () => {
        const score = JSON.parse(JSON.stringify(getScore(this.props.plan, this.props.task))) as IScore;
        score.settings.notehead = "handsign";
        score.settings.stick = false;
        score.settings.staffLines = true;
        score.settings.upperText = 1;
        score.settings.lowerText = undefined;
        score.settings.lowerText2 = undefined;
        this.setState({
            taskScore: score,
            completed: true,
            submited: true,
            currentNote: null,
            activeVoice: 0,
        });
    };
    componentDidMount() {
        this.setUp();
    }

    componentWillUnmount() {
        window.removeEventListener("blur", this.blur);
        clearTimeout(this.failedNoteTimer);
        if (this.state.playing) {
            this.play();
        }
    }

    blur = () => {
        this.play();
    };

    handleInput = async (s: IPitch["s"], o: IPitch["o"], e: MouseEvent | TouchEvent) => {
        await handleTouch(e);
        let { playing, activeVoice, alteration: a } = this.state;
        const taskScore = this.state.taskScore!;
        const accidentals = getAccidentals(taskScore);
        const currentNote = this.state.currentNote!;
        const {
            task,
            plan,
            solfaAudio,
            task: {
                data: { showPitches },
            },
            intl: { locale },
        } = this.props;
        const score = getScore(plan, task)!;
        const barsKey = "bars" + (activeVoice || "");
        let bar = taskScore[barsKey][currentNote.bar];
        let originalBar = score[barsKey][currentNote.bar];
        if (!bar) return;
        let note = bar.notes[currentNote.note];
        let originalNote = originalBar.notes[currentNote.note];
        if (!note) return;
        const doPos = parseDo(accidentals[currentNote.bar]);
        let pianoNote =
            60 +
            pianoParser[s] +
            (a || 0) +
            getKeyOffset(doPos.value + 6) +
            doPos.alt +
            ((o || 0) + (taskScore["octave" + activeVoice] || 0)) * 12;
        const playNote = {
            pianoNote,
            doPos: accidentals[currentNote.bar],
            p: {
                s,
                o,
                a,
            },
            octave: taskScore["octave" + activeVoice] || 0,
            locale,
            clef: score[`clef${activeVoice || ""}`] || "treble",
            type: solfaAudio,
            isLala: false,
        };
        if (!playing) {
            let loaded = voices.load(playNote);
            if (loaded) {
                voices.play(playNote);
            }
        }

        if (
            showPitches &&
            (originalNote.p.s !== s || (originalNote.p.a || 0) !== (a || 0) || (originalNote.p.o || 0) !== (o || 0))
        ) {
            return this.failedInput();
        } else {
            this.setState({ failedNote: false });
        }

        note.p = {
            s,
            o,
            a,
        };
        if (note.tie) {
            let nextNote = bar.notes[currentNote.note + 1];
            if (!nextNote) {
                nextNote = taskScore[barsKey][currentNote.bar + 1].notes[0];
            }
            nextNote.p = { s, o, a };
        }
        let lastNote: ICurrentNote;
        let lastCurrentNote = { ...currentNote };
        do {
            lastNote = { ...currentNote };
            currentNote.note++;
            if (bar.notes.length === currentNote.note) {
                currentNote.bar++;
                bar = taskScore[barsKey][currentNote.bar];
                currentNote.note = 0;
            }
        } while (
            (bar && bar.notes.length && bar.notes[currentNote.note].r) ||
            taskScore[barsKey][lastNote.bar].notes[lastNote.note].tie
        );
        if (lastCurrentNote.bar !== currentNote.bar && accidentals[currentNote.bar] && accidentals[lastCurrentNote.bar] && accidentals[lastCurrentNote.bar].i !== accidentals[currentNote.bar].i) {
            this.showModulationPopup(currentNote.bar, note.p, pianoNote);
        }
        setTimeout(() => {
            if (score[barsKey][currentNote.bar]) {
                scrollToBar(this.distribution!, this.scoreRef!, currentNote.bar);
            }
        }, 500);
        this.setState({ taskScore: { ...taskScore }, currentNote, alteration: 0 }, this.checkReady);
    };

    showModulationPopup = (nextBar: number, prevPitch: IPitch, nextPianoNote: number) => {
        const {
            task,
            plan,
        } = this.props;
        const { activeVoice } = this.state;
        const score = getScore(plan, task)!;
        const accidentals = getAccidentals(score);
        const nextAcc = accidentals[nextBar];
        const activeVoiceOctave = score["octave" + (activeVoice || "0")] || 0 as IPitch["o"];
        setTimeout(() => {
            this.setState({
                popupModulation: {
                    nextAcc,
                    prevPitch,
                    nextPianoNote,
                    activeVoiceOctave,
                }
            });
        }, 100);
    }

    closeModulationPopup = () => {
        this.setState({ popupModulation: undefined });
    }

    setRef = (ref: HTMLDivElement) => {
        this.scoreRef = ref;
    };
    setDistribution = (distribution: number[][]) => {
        this.distribution = distribution;
    };

    setAlteration = (way: 1 | -1) => {
        const { alteration } = this.state;
        if (alteration === way) {
            this.setState({ alteration: 0 });
        } else {
            this.setState({ alteration: way });
        }
    };

    render() {
        const {
            incorrectNotes,
            submitable,
            submited,
            playable,
            currentNote,
            playing,
            checkPlaying,
            completed,
            solfaNameTypes,
            taskScore,
            activeVoice,
            failedNote,
            playingNote,
            alternatedPitches,
            alteration,
            popupModulation,
        } = this.state;
        const { task, isLow, isDemo, plan, handleHomeworkNext, isEaster, isChristmas } = this.props;
        const { data } = task;
        const score = getScore(plan, task);
        if (!data || !playable)
            return (
                <div>
                    <div>
                        <Wrapper>
                            <NotEdited />
                        </Wrapper>
                    </div>
                </div>
            );
        let scale = getScale(plan, task);
        const { hint } = data;
        const { hasFlat, hasSharp } = getAlternates(alternatedPitches);
        return (
            <div>
                <Wrapper isDemo={isDemo}>
                    {isLow && (
                        <>
                            <Asset1Wrapper>
                                <img src={getBirdsPath("/handSign/asset-01.svg")} alt="decoration" />
                            </Asset1Wrapper>
                            <Asset2Wrapper>
                                <img src={getBirdsPath("/solfaName/asset-02.svg")} alt="decoration" />
                            </Asset2Wrapper>
                            <Asset3Wrapper>
                                <img src={getBirdsPath("/solfaName/asset-03.svg")} alt="decoration" />
                            </Asset3Wrapper>
                        </>
                    )}
                    {isEaster && (
                        <EasterBackground />
                    )}
                    {isChristmas && (
                        <ChristmasBackground />
                    )}
                    <ScoreWrapper isLow={!!isLow} isEaster={isEaster || isChristmas}>
                        {taskScore && (
                            <Score
                                score={taskScore}
                                handSign
                                showPitches={!completed && (data.showPitches || false)}
                                {...((data.showPitches || !submited) && { currentNote: currentNote! })}
                                selectNote={this.selectNote}
                                activeVoice={activeVoice}
                                playingNote={playingNote}
                                scale={scale * (isLow ? 0.5425 : (isEaster || isChristmas) ? (996 / ar.width) : (1280 - handSignWidth) / 1280)}
                                incorrectNotes={incorrectNotes}
                                themeColor={data.color}
                                whiteBackground={isLow}
                                playing={playing}
                                checkPlaying={checkPlaying}
                                setRef={this.setRef}
                                setDistribution={this.setDistribution}
                                isEaster={isEaster || isChristmas}
                            />
                        )}
                    </ScoreWrapper>
                    <HandSignLadderWrapper className={cn(completed && "Completed")} isLow={!!isLow}>
                        <HandSignLadder
                            alteration={alteration}
                            alternatedPitches={alternatedPitches}
                            handleInput={this.handleInput}
                            solfaNameTypes={solfaNameTypes}
                            withColors={!!score!.settings.colors}
                            hint={
                                !!(currentNote &&
                                    this.firstPitch &&
                                    this.firstPitch.bar === currentNote.bar &&
                                    this.firstPitch.note === currentNote.note &&
                                    hint)
                            }
                            currentNote={
                                currentNote &&
                                score?.["bars" + (activeVoice || "")][currentNote.bar]?.notes?.[currentNote.note]
                            }
                        />
                        {hasSharp && (
                            <HandSignSharpButton
                                className={cn({ active: alteration === 1 })}
                                onClick={() => this.setAlteration(1)}
                            >
                                <Icon i="arrowup" />
                            </HandSignSharpButton>
                        )}
                        {hasFlat && (
                            <HandSignFlatButton
                                className={cn({ active: alteration === -1 })}
                                onClick={() => this.setAlteration(-1)}
                            >
                                <Icon i="arrowup" />
                            </HandSignFlatButton>
                        )}
                    </HandSignLadderWrapper>
                    <PlayBtn
                        className={cn("button", "button--play")}
                        isEaster={isEaster}
                        resetPlay={this.pauseOffset && !playing && !this.isCheckPlayPause ? resetPlay.bind(this as unknown as INotationThis) : undefined}
                        onClick={() => {
                            if (isMobile) return;
                            this.play();
                        }}
                        onTouchStart={() => {
                            if (isMobile) this.play();
                        }}
                        isLow={isLow}
                        disabled={checkPlaying}
                    >
                        {playing && !checkPlaying ? <Icon i="pause" /> : <Icon i="play" />}
                        <Label>
                            <FormattedMessage {...messages.play} />
                        </Label>
                    </PlayBtn>
                    <TopRight isLow={isLow} handleLeftBottom={true}>
                        {!completed && !data.showPitches && (
                            <DeleteButton
                                isLow={isLow}
                                isEaster={isEaster}
                                style={{
                                    bottom: "auto",
                                    left: "auto",
                                    padding: 16,
                                    paddingBottom: 6,
                                    paddingTop: 6,
                                    width: "auto",
                                    fontWeight: 400,
                                }}
                                className={cn("button", "button--info")}
                                onClick={() => {
                                    this.deletePitch();
                                }}
                            >
                                <FormattedMessage {...messages.delete} />
                            </DeleteButton>
                        )}
                        {!data.showPitches && (
                            <CheckPlayBtn
                                isLow={isLow}
                                isEaster={isEaster}
                                resetPlay={this.pauseOffset && this.isCheckPlayPause && !playing ? resetPlay.bind(this as unknown as INotationThis) : undefined}
                                className={cn("button", "button--check")}
                                onClick={() => this.play(false, undefined, undefined, true)}
                                disabled={(playing && !checkPlaying) || completed}
                            >
                                {checkPlaying ? <Icon i="pause" /> : <Icon i="play" />}
                                <Label>
                                    <FormattedMessage {...messages.check} />
                                </Label>
                            </CheckPlayBtn>
                        )}
                    </TopRight>
                    {submitable && !completed && !incorrectNotes.length && (
                        <SubmitButton
                            isLow={isLow}
                            isEaster={isEaster}
                            style={{
                                top: isLow ? 30 : 6,
                                bottom: "auto",
                                right: "auto",
                                left: 540,
                                paddingBottom: 5,
                                paddingTop: 5,
                            }}
                            className={cn("button")}
                            onClick={() => {
                                if (submitable) {
                                    this.submit();
                                }
                            }}
                        >
                            <FormattedMessage {...messages.submit} />
                        </SubmitButton>
                    )}
                    {completed && (
                        <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="completed" handleHomeworkNext={handleHomeworkNext} />
                    )}
                    {submited && !completed && <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="incorrect" />}
                    {failedNote && !completed && <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="incorrectNote" />}
                    {!!popupModulation && <PopupModulation {...popupModulation} onClose={this.closeModulationPopup} />}
                </Wrapper>
            </div>
        );
    }
}

export default HandSign;
